
import React, { createContext, useState,useEffect } from "react";
// import {getFromLocalStorage} from '../components/helper/task'
const TaskContext=createContext()

const TaskProvider=({children})=>{
    const [task,setTask]=useState(
         
    );
    
    

    return(
    <TaskContext.Provider value={[task,setTask]}>
        {children}
    </TaskContext.Provider>)
}

export {TaskContext,TaskProvider}